import { supabase } from '@/config/supabase'
import type { PaginatedResult } from './associado.service'

export interface Split {
    id: string
    fatura_id: string
    parceiro_id: string
    valor: number
    status: 'pendente' | 'pago' | 'cancelado'
    data_pagamento: string | null
    created_at: string
    parceiro?: { nome: string }
    fatura?: { 
        data_vencimento: string,
        contrato: {
            associado: { nome: string }
        }
    }
}

export const splitService = {
    async list(filters: { parceiro_id?: string, status?: string, page?: number, pageSize?: number } = {}): Promise<PaginatedResult<Split>> {
        const { parceiro_id, status, page = 1, pageSize = 10 } = filters

        let query = supabase
            .schema('veicular_system')
            .from('veic_splits')
            .select(`
                *,
                parceiro:veic_parceiros(nome),
                fatura:veic_faturas(
                    data_vencimento,
                    contrato:veic_contratos(
                        associado:veic_associados(nome)
                    )
                )
            `, { count: 'exact' })
            .order('created_at', { ascending: false })

        if (parceiro_id && parceiro_id !== 'todos') {
            query = query.eq('parceiro_id', parceiro_id)
        }
        if (status && status !== 'todos') {
            query = query.eq('status', status)
        }

        const from = (page - 1) * pageSize
        query = query.range(from, from + pageSize - 1)

        const { data, count, error } = await query
        if (error) throw error

        return {
            data: (data || []) as Split[],
            total: count || 0,
            page,
            pageSize,
            totalPages: Math.ceil((count || 0) / pageSize),
        }
    }
}
